export default "__VITE_ASSET__IWCKqS9u__"